function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#5c195f}");
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M85.5 10h-5V0h-10v10h-40V0h-10v10h-5c-5.5 0-9.9 4.5-9.9 10l-.1 70c0 5.5 4.5 10 10 10h70c5.5 0 10-4.5 10-10V20c0-5.5-4.5-10-10-10zm0 80h-70V35h70v55z",
  className: "st0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7 41.2h9.8V51h-9.8zM46 41.2h9.8V51H46zM67.5 41.2h9.8V51h-9.8z",
  className: "st0"
});
const SvgIcAvsCalendar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  id: "Capa_1",
  x: 0,
  y: 0,
  style: {
    enableBackground: "new 0 0 100 100"
  },
  viewBox: "0 0 100 100",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcAvsCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-avs-calendar.083aa658.svg";
export { ForwardRef as ReactComponent };